document.addEventListener("DOMContentLoaded", function () {
	const splideElem = document.querySelector(".mm-articles-splide");

	if (!splideElem) {
		return;
	}
	const splideArticles = new Splide(splideElem, {
		type: "slide",
		arrows: true,
		pagination: true,
		autoWidth: true,
		focus: 0,
		omitEnd: true,
		gap: 16,
		breakpoints: {
			768: {
				gap: 12,
			},
		},
	});

	splideArticles.mount();
});

// demander apres une certaine taille de destroy voir le rendu